import React, { Component } from "react";
import edit from "./ModalVideo.scss";
import axios from "axios";
import { Env } from "../../env";

class ModalVideo extends Component {
  constructor() {
    super();
    this.state = {
      loader: true,
    };
  }

  onLoad = async () => {
    console.log("onload");
    if (this.state.loader) {
      this.setState({
        loader: false,
      });
    }

    // Save video view
    try {
      await axios.get(
        `${Env.BASE_API_URL}/Videos/saveVideoView?videoId=${this.props.video.id}`
      );
    } catch (error) {
      console.log("err", error);
    }
  };

  render() {
    return (
      // Modal with iframe
      <div>
        <div className={edit.content}>
          <video
            controls
            autoPlay
            controlsList="nodownload"
            id={edit.iframe}
            onLoadedData={this.onLoad}
          >
            <source src={this.props.srcIframe} type="video/mp4"></source>
            Veuillez essayer depuis un autre navigateur
          </video>
          {this.state.loader && (
            <div id={edit.loader} className={edit.three}>
              <div className={edit.loader} id={edit.loader_7}></div>
            </div>
          )}
          <a
            id={edit.btnCloseModal}
            onClick={() => {
              this.props.backToTheWall();
            }}
          >
            Fermer la vidéo
          </a>
        </div>
      </div>
    );
  }
}

export default ModalVideo;



// WEBPACK FOOTER //
// ./src/pages/patientplaylist/ModalVideo.jsx